import { cn } from "@garther/ui/libs";
import React from "react";

interface IButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  variant?: "default" | "outline" | "ghost" | "inverse" | "inverse-outline";
  padding?: string | null;
  isDisabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const Button = (props: IButton) => {
  const {
    children,
    className,
    variant = "default",
    onClick,
    isDisabled = false,
    padding = null,
    ...rest
  } = props;

  const baseClasses = cn(
    "inline-flex items-center justify-center rounded-sm transition-all duration-300 transform hover:scale-[1.04] disabled:opacity-50 disabled:cursor-not-allowed text-responsive-base",
    padding === null ? "px-2 sm:px-5 md:px-6 py-2 sm:py-3" : padding
  );

  const variantClasses = {
    default: "bg-background-dark text-text-inverse",
    outline: "border border-border-dark text-text-primary",
    ghost: "bg-transparent text-text-primary",
    inverse: "bg-background-primary text-text-primary",
    "inverse-outline":
      "border border-background-primary bg-transparent text-background-primary",
  };

  return (
    <button
      className={cn(baseClasses, variantClasses[variant], className)}
      onClick={onClick}
      disabled={isDisabled}
      {...rest}
    >
      {children}
    </button>
  );
};
